import type { Selection } from '../../contexts/ItemContext';

// Convert time range to sentence indices
export function timeToSentenceIndices(
  selection: Selection,
  timeMap: number[]
): { startIdx: number; endIdx: number } | null {
  if (
    selection.startSeconds === null ||
    selection.endSeconds === null ||
    !timeMap.length
  ) {
    return null;
  }

  let startIdx = 0;
  for (let i = 0; i < timeMap.length; i++) {
    const time = timeMap[i];
    if (time !== undefined && time <= selection.startSeconds) startIdx = i;
    else break;
  }

  let endIdx = startIdx;
  for (let i = startIdx; i < timeMap.length; i++) {
    const time = timeMap[i];
    if (time !== undefined && time < selection.endSeconds) endIdx = i;
    else break;
  }

  return { startIdx, endIdx };
}

// Convert sentence indices to time range
export function sentenceIndicesToTime(
  startIdx: number,
  endIdx: number,
  timeMap: number[]
): { startSeconds: number; endSeconds: number } | null {
  if (!timeMap.length) return null;

  const minIdx = Math.min(startIdx, endIdx);
  const maxIdx = Math.max(startIdx, endIdx);

  const startSeconds = timeMap[minIdx] ?? 0;

  let endSeconds: number;
  if (maxIdx + 1 < timeMap.length) {
    endSeconds = timeMap[maxIdx + 1] ?? startSeconds + 30;
  } else {
    endSeconds = (timeMap[maxIdx] ?? 0) + 10;
  }

  if (endSeconds <= startSeconds) {
    endSeconds = startSeconds + 10;
  }

  return { startSeconds, endSeconds };
}
